<template>
  <div>
    <el-card v-if="$route.path == '/serviceManage'">
      <div class="forms">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="名称">
            <el-select v-model="form.moduleId" clearable>
              <el-option v-for="(item, index) in selectListData" :label="item.moduleName" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="searchData">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-popconfirm title="您确定要删除多条数据吗？" @confirm="deleteData">
              <el-button class="white" slot="reference">删除</el-button>
            </el-popconfirm>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBorderColor" @click="exportData">导入</el-button>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="addHomeData('dialogForm')">新增服务</el-button>
          </el-form-item>
        </el-form>
        <div class="tableData">
          <el-table ref="table" v-loading="loading" :data="tableData" border tooltip-effect="dark" style="width: 100%; margin-top: 20px" @selection-change="handleSelectionChange" max-height="650">
            <el-table-column type="selection" width="55" align="center" />
            <el-table-column prop="moduleName" label="模块" min-width="140" align="center" />
            <el-table-column prop="serviceName" label="名称" min-width="80" align="center" />
            <el-table-column prop="imgUrl" label="图片" min-width="80" align="center">
              <template #default="scope">
                <img style="width: 50px; height: 50px" :src="`${uploadUrl}+${scope.row.imgUrl}`" alt="" />
              </template>
            </el-table-column>
            <el-table-column prop="jumpLink" label="跳转链接" min-width="160" show-overflow-tooltip align="center">
              <template #default="scope">
                <a class="aHref" href="JavaScript:;">{{ scope.row.jumpLink }}</a>
              </template>
            </el-table-column>
            <el-table-column prop="updatedTime" label="变更时间" min-width="120" align="center" />
            <el-table-column prop="updatedBy" label="变更人" min-width="120" align="center" />
            <el-table-column prop="remark" label="备注" show-overflow-tooltip min-width="260" align="center" />
            <el-table-column label="操作" align="center" min-width="100" fixed="right">
              <template #default="scope">
                <div class="operate">
                  <div class="btn" @click="edit(scope.row)">编辑</div>
                  <el-popconfirm title="您确认要删除该条数据吗？" @confirm="deleteOnly(scope.row)">
                    <div slot="reference" class="btn">删除</div>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pageContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageData.page" :page-sizes="[20, 40, 60, 80, 100]" :page-size="pageData.pageSize" layout="total, prev, pager, next,sizes" :total="total"> </el-pagination>
        </div>
      </div>
      <Export ref="exportDialog" :type="type" :downloadTitle="downloadTitle" :getSearchList="getSearchList"></Export>
    </el-card>

    <el-dialog :title="`${title}服务`" :visible.sync="dialogVisible" width="750px" @close="cancelBtn('dialogForm')">
      <div class="forms">
        <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="160px" class="demo-dialogForm" label-position="left">
          <el-form-item label="选择模块" prop="moduleId">
            <el-select v-model="dialogForm.moduleId" clearable>
              <el-option v-for="item in selectListData" :label="item.moduleName" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务名称" prop="serviceName">
            <el-input v-model="dialogForm.serviceName"></el-input>
          </el-form-item>
          <el-form-item label="图片跳转链接" prop="jumpLink">
            <el-input v-model="dialogForm.jumpLink"></el-input>
          </el-form-item>
          <el-form-item label="请选择图片" prop="imgUrl" ref="imgUpload">
            <!-- 上传 -->
            <el-upload class="avatar-uploader" :action="`${upload}/file/uploadNew`" :show-file-list="false" :on-success="uploadSuccess" list-type="picture-card">
              <img v-if="imgUrl" :src="imgUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="dialogForm.remark" placeholder="请输入备注内容"></el-input>
          </el-form-item>
          <div class="footerBtn">
            <el-button class="dialogWhite" @click="cancelBtn('dialogForm')">取 消</el-button>
            <el-button class="dialogBtnBackgory" @click="submitForm('dialogForm')">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
import Export from "../exportFile/export.vue";
export default {
  name: "serviceManage",
  components: {
    Export
  },
  data() {
    return {
      form: {
        moduleId: ""
      },

      ids: [],
      title: "新增",
      selectListData: [],
      loading: false,
      pageData: {
        page: 1,
        pageSize: 20
      },

      total: 0,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        moduleId: "",
        serviceName: "",
        jumpLink: "",
        imgUrl: "",
        remark: ""
      },
      imgUrl: "",
      uploadUrl: "",
      upload: "",
      dialogRules: {
        moduleId: [{ required: true, message: "请选择区域", trigger: "change" }],
        serviceName: [{ required: true, message: "请输入服务名称", trigger: "blur" }],
        jumpLink: [{ required: true, message: "请输入图片跳转链接", trigger: "blur" }],
        imgUrl: [{ required: true, message: "请选择图片" }]
      },
      type: "gzh_service",
      downloadTitle: "服务配置导入模板"
    };
  },
  mounted() {
    this.upload = apis.upload;
    this.uploadUrl = apis.uploadUrl;
    this.getSeleteDataList();
    this.getSearchList({ ...this.pageData });
  },
  methods: {
    // 获取 下拉 数据
    getSeleteDataList() {
      if (this.$route.path == "/serviceManage") {
        apis.servicesGetModuleList().then(res => {
          if (res.code === 200) {
            this.selectListData = res.data;
          }
        });
      }
    },
    // table 选中
    handleSelectionChange(val) {
      this.ids = val.map(item => item.id);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    exportData() {
      this.$refs.exportDialog.dialogVisible = true;
    },
    // 新增
    addHomeData(formName) {
      this.getSeleteDataList();
      this.dialogVisible = true;
      this.title = "新增";
      this.dialogForm = {};
      this.imgUrl = "";
      this.$refs[formName]?.resetFields();
    },
    //图片上传成功
    uploadSuccess(res) {
      if (res.code === 200) {
        this.dialogForm.imgUrl = res.data.id;
        this.imgUrl = apis.uploadUrl + res.data.id;
        this.$refs["imgUpload"].clearValidate();
      }
    },

    // 获取 table 数据
    getSearchList(json) {
      if (this.$route.path == "/serviceManage") {
        this.loading = true;
        apis.serviceList(json).then(res => {
          if (res.code === 200) {
            this.tableData = res.data;
            this.total = res.total;
            this.loading = false;
          }
        });
      }
    },
    // 搜索
    searchData() {
      const json = {
        ...this.pageData,
        ...this.form
      };
      this.getSearchList(json);
    },
    // 批量 删除
    deleteData() {
      if (this.ids.length && this.$route.path == "/serviceManage") {
        apis.servicesDeleteService(this.ids).then(res => {
          if (res.code === 200) {
            this.getSearchList({ ...this.pageData });
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
      }
    },
    // 确认 添加
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const json = {
            ...this.dialogForm
          };
          if (this.$route.path == "/serviceManage") {
            apis.servicesAddAndEditService(json).then(res => {
              if (res.code === 200) {
                this.getSearchList({ ...this.pageData });
                this.dialogVisible = false;
                const msg = this.dialogForm.id ? "修改" : "新增";
                this.$message({
                  message: `${msg}成功`,
                  type: "success"
                });
              }
            });
          }
        }
      });
    },
    //dialog 取消按钮
    cancelBtn(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 编辑
    edit(row) {
      this.imgUrl = apis.uploadUrl + row.file.id;
      this.dialogForm = JSON.parse(
        JSON.stringify({
          id: row.id,
          moduleId: row.moduleId,
          serviceName: row.serviceName,
          jumpLink: row.jumpLink,
          imgUrl: row.file.id,
          remark: row.remark
        })
      );
      this.dialogVisible = true;
      this.title = "编辑";
    },
    // 删除一条
    deleteOnly(row) {
      if (this.$route.path == "/serviceManage") {
        apis.servicesDeleteService([row.id]).then(res => {
          if (res.code === 200) {
            this.getSearchList({ ...this.pageData });
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  margin: 20px;
}
::v-deep .el-dialog__title {
  display: flex;
  align-items: center;
  font-size: 29px;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 29px;
    background-color: #008754;
    margin-right: 10px;
  }
}
.forms {
  .el-button--mini {
    margin-right: 20px;
  }
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
  }
  .white {
    width: 181px;
    height: 54px;
  }
  .btnBorderColor {
    width: 181px;
    height: 54px;
    color: #008754;
    border-color: #008754;
  }
  ::v-deep .el-form {
    .left {
      .el-input--mini .el-input__inner {
        width: 295px;
      }
    }
    .footerBtn {
      text-align: right;
      .dialogWhite {
        width: 145px;
        height: 54px;
      }
      .dialogBtnBackgory {
        width: 145px;
        height: 54px;
        background-color: #008754;
        color: white;
      }
    }
  }
  ::v-deep .el-upload {
    width: 178px;
    height: 178px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  ::v-deep .el-upload:hover {
    border-color: #409eff;
  }
  ::v-deep .el-upload--picture-card {
    line-height: 178px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.aHref {
  color: #5e92ff;
}
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
::v-deep .el-dialog {
  .el-form {
    .el-input {
      width: 770px;
    }
    .el-textarea__inner {
      width: 770px;
    }
  }
}
</style>
